<template>
  <div class="redirect-external-links">
    <modal
      ref="loadingRedirectLink"
      template="loading"
      title="Aguarde"
      ref-name="loadingRedirectLink"
      class="shopping-feedback"
    >
      <p>Carregando</p>
    </modal>
    <modal
      ref="failedShoppingCentralLogin"
      template="question"
      title="Aviso"
      ref-name="failedShoppingCentralLogin"
      class="shopping-feedback"
      second-button-text="Ok"
      :hide-first-button="true"
      :close-button-enabled="false"
      @second-cta="closeFailedShoppingCentralLoginModal()"
    >
      <div class="modal-container">
        <div class="content">
          <div class="img-wrapper">
            <img
              src="/static/images/icon-alert-modal.svg"
              alt="icone-alerta"
            >
          </div>
          <p>
            Este laboratório <b>não possui acesso à Central de Compras</b>. Por favor,
            entre em contato com o Executivo de Vendas responsável,
            ou obtenha suporte pelo telefone <b>0800-643-8100</b> opção 3.
          </p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { stripCnpjMask } from '@/utils/cnpj-utils'

const ENV_OLD_SITE = 'OLD_SITE'
const ENV_LAUDASA = 'LAUDASA'
const ENV_CHROMATOX = 'CHROMATOX'
const ENV_SHOPPING_CENTER = 'SHOPPING_CENTER'

export default {
  name: 'RedirectExternalLinks',
  data: () => ({
    env: '',
    path: ''
  }),
  methods: {
    ...mapActions(['callServiceTokenLaudasa', 'callServiceTokenChromatox', 'callServiceShoppingCentralCredentials']),
    openLoadingModal () {
      this.$refs.loadingRedirectLink.open()
    },
    closeLoadingModal () {
      this.$refs.loadingRedirectLink.close()
    },
    openFailedShoppingCentralLoginModal () {
      this.$refs.failedShoppingCentralLogin.open()
    },
    closeFailedShoppingCentralLoginModal () {
      this.$refs.failedShoppingCentralLogin.close()
    },
    redirect (url) {
      window.open(url)
    },
    async getTokenAndRedirect (env, path) {
      this.env = env
      this.path = path

      this.openLoadingModal()

      let self = this
      await this.getToken().then(function (credential) {
        if (self.env === 'SHOPPING_CENTER') {
          self.openShoppingCentral()
        } else {
          self.openExternalLink(credential)
        }
        self.submitAnalyticsEvent(env)
      })
    },
    getToken () {
      let self = this
      return new Promise((resolve, reject) => {
        switch (this.env) {
          case ENV_LAUDASA:
          case ENV_OLD_SITE:
            this.callServiceTokenLaudasa().then(function () {
              resolve(self.laudasaToken)
            })
            break
          case ENV_CHROMATOX:
            this.callServiceTokenChromatox().then(function () {
              resolve(self.chromatoxToken)
            })
            break
          case ENV_SHOPPING_CENTER:
            this.callServiceShoppingCentralCredentials().then(function () {
              resolve(self.shoppingCentralCredentials)
            })
            break
        }
      })
    },
    buildUrl (token) {
      switch (this.env) {
        case 'LAUDASA':
          return this.buildLaudasaURL(token)
        case 'CHROMATOX':
          return this.buildChromatoxURL(token)
        case 'OLD_SITE':
          return this.buildOldSiteURL(token)
      }
    },
    openExternalLink (token) {
      let url = this.buildUrl(token)
      this.redirect(url)
      this.closeLoadingModal()
    },
    buildLaudasaURL (token) {
      return process.env.URL_LAUDASA.toString() + token
    },
    buildChromatoxURL (token) {
      return (
        process.env.URL_CHROMATOX.toString() +
        this.profile.id_laboratory.toString() +
        '&tk=' +
        token
      )
    },
    buildOldSiteURL (token) {
      return (
        process.env.URL_OLD_SITE.toString() + token + '&redirect=' + this.path
      )
    },
    openShoppingCentral () {
      this.loginShoppingCentral()
        .then(() => {
          this.closeLoadingModal()
        })
        .catch((error) => {
          this.closeLoadingModal()
          this.openFailedShoppingCentralLoginModal()
          this.submitAnalyticsEvent(
            'SHOPPING_CENTER - error: ' + error.message
          )
        })
    },
    loginShoppingCentral () {
      const cnpj = stripCnpjMask(this.profile.laboratoryCnpj)
      const key = cnpj.substring(0, 4) + cnpj.substring(cnpj.length - 4, cnpj.length)
      // Method LoginIntegradoAC is from script added via Google Tag Manager (Script Central de Compras)
      return new Promise(async (resolve, reject) => {
        try {
          /* eslint-disable */
          await LoginIntegradoAC.logon(cnpj, key);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    submitAnalyticsEvent(action) {
      this.$analytics.pushAnalyticsEvent("ga-event", {
        category: "Links Externos com integração com login",
        action: action,
        "id-user": this.profile.id,
        "id-lab": this.profile.id_laboratory,
        "name-lab": this.profile.laboratoryName,
      });
    },
  },
  computed: {
    ...mapGetters(["laudasaToken", "chromatoxToken", "shoppingCentralCredentials", "profile"]),
  }
};
</script>

<style lang="scss" scoped>
.shopping-feedback {
  .md-dialog-content {
    max-width: 540px;
    .modal-container {
      margin-bottom: 13px;
      .content {
        text-align: left;
        color: #4a4a4a;
        font-size: 14px;
        padding: 13px 12px 12px;
        background-color: #fdedd3;
        max-width: 420px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        border-radius: 5px;
        .img-wrapper {
          width: 32px;
        }
        p {
          width: calc(100% - 32px);
        }
      }
    }
  }

  .md-button {
    margin: 0 auto;
  }
}
</style>
